import * as _ from 'lodash';
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IProject, IProposition } from 'src/model';
import { listProjectPropositions } from 'src/services';
import { PropositionList } from './PropositionList';

interface IProjectPropositionsProps {
  project: IProject;
  handleProjectChange?: (project : IProject) => void;
}

interface IProjectPropositionsState {
  propositionList: IProposition[];
}

export class ProjectPropositions extends React.Component<
  IProjectPropositionsProps,
  IProjectPropositionsState
> {
  constructor(props: IProjectPropositionsProps) {
    super(props);
    this.state = {
      propositionList: [],
    };
  }

  public handlePropositionListChange = async () => {
    const propositionList = await listProjectPropositions(
      this.props.project._id
    );
    this.setState({ propositionList });
  };

  public async componentDidMount() {
    const propositionList = await listProjectPropositions(
      this.props.project._id
    );
    if (propositionList) {
      this.setState({ propositionList });
    }
  }


  public async componentWillReceiveProps(nextProps: IProjectPropositionsProps) {
    if (nextProps.project !== this.props.project) {
      const propositionList = await listProjectPropositions(
        nextProps.project._id
      );
      if (propositionList) {
        this.setState({ propositionList });
      }
    }
  }


  public render() {
   // const sentFilter = (proposition: IProposition) =>
   // proposition.meta.status === 'sent';
    const validatedFilter = (proposition: IProposition) =>
      proposition.meta.status === 'validated';
    const shortlistedFilter = (proposition: IProposition) =>
      proposition.meta.status === 'shortlisted';
    const refusedFilter = (proposition: IProposition) =>
      (proposition.meta.status === 'refused' || proposition.meta.status === 'rejected') && !!proposition.title;
    const acceptedFilter = (proposition: IProposition) =>
      proposition.meta.status === 'accepted';

    const { project , handleProjectChange} = this.props;
    const { propositionList } = this.state;

    return (
      <Row className='p-5'>
        <Col md='12'>
          <span className='text-dark' style={{ fontSize: '32px' }}>
            {project.title}
          </span>
          <Row className='mt-5'>
            {project.meta.status === 'initial' ||
            project.meta.status === 'validated' ? (
              <Col md='12'>
                <PropositionList
                  label={'Nouvelles propositions'}
                  propositionList={propositionList}
                  src='new'
                  filter={validatedFilter}
                  handlePropositionListChange={this.handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                  
                />
                <PropositionList
                  label='Propositions shortlistées'
                  propositionList={propositionList}
                  src='selecting'
                  filter={shortlistedFilter}
                  handlePropositionListChange={this.handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                />
                <PropositionList
                  label='Propositions refusées'
                  propositionList={propositionList}
                  src='finger-wagging'
                  filter={refusedFilter}
                  handlePropositionListChange={this.handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                />
              </Col>
            ) : (
              <Col md='12'>
                <PropositionList
                  label={'Proposition choisie'}
                  propositionList={propositionList}
                  src='new'
                  filter={acceptedFilter}
                  handlePropositionListChange={this.handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                />
                <PropositionList
                  label='Propositions refusées'
                  propositionList={propositionList}
                  src='finger-wagging'
                  filter={refusedFilter}
                  handlePropositionListChange={this.handlePropositionListChange}
                  handleProjectChange={handleProjectChange}
                />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositions.tsx